<ion-header #header [hidden]="isStreamView">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button [defaultHref]="getBackRoute()"></ion-back-button>
        </ion-buttons>
        <ion-title>{{ 'Match Tracker' | translate }}</ion-title>
        <ion-buttons slot="end">
            <app-login-modal *ngIf="!authService.authUserSignal()" (isAuthenticated)="isAuthenticated()"></app-login-modal>
            <app-share-match #share [matchId]="matchId" [position]="'header'"></app-share-match>
            <app-follow-match *ngIf="match && authService.authUserSignal() && !isOwner" [match]="match"></app-follow-match>
            <ion-menu-button *ngIf="match?.tie" class="ion-hide-sm-up" menu="tracker" autoHide="false"></ion-menu-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content #content *ngIf="match">
    <ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <!-- Scoreboard -->
    <app-scoreboard [match]="match" (completeTimedSet)="board.completeTimedSet()" (addGame)="board.addGame($event)" (addPoint)="board.addPoint($event)" (undo)="board.undo()" #scoreboard></app-scoreboard>

    <ng-container *ngIf="match?.matchStatus === 'TBP' && !isStreamView">
        <app-empty-page text="{{'Match has not started' | translate}}" iconName="tennisball"></app-empty-page>
    </ng-container>

    <div [hidden]="!matchActive || !match.sets.length || isStreamView">
        <ion-toolbar #segmentToolbar class="content-width">
            <ion-segment color="dark" #segment scrollable [value]="segmentValue">
                <ion-segment-button value="tracker" *ngIf="isTracker">
                    <ion-label>{{ 'Tracker' | translate }}</ion-label>
                </ion-segment-button>
                <ion-segment-button value="points">
                    <ion-label>{{ 'Points' | translate }}</ion-label>
                </ion-segment-button>
                <ion-segment-button value="momentum">
                    <ion-label>{{ 'Momentum' | translate }}</ion-label>
                </ion-segment-button>
                <ion-segment-button value="stats">
                    <ion-label>{{ 'Stats' | translate }}</ion-label>
                </ion-segment-button>  
                <!-- *ngIf="match.dist.media.length>0" -->
                <ion-segment-button value="video" *ngIf="isVideoStreaming">
                    <ion-label>{{ 'Video' | translate }}</ion-label>
                </ion-segment-button>
            </ion-segment>
        </ion-toolbar>
    </div>

    <!-- Tracker board -->
    <div [hidden]="segment?.value !== 'tracker' || isStreamView" class="scoreboard-margin">
        <app-tracker-board [hidden]="isSuspended" [segmentToolbar]="44" [header]="header?.el.offsetHeight - 10" [match]="match" (updatedMatch)="updateMatch($event)" #board></app-tracker-board>
    </div>

    <!-- Point by point -->
    <div *ngIf="segment?.value === 'points' && !isStreamView" class="scoreboard-margin">
        <app-score-list [match]="match"></app-score-list>
    </div>

    <!-- Momentum -->
    <div *ngIf="segment?.value === 'momentum'" class="scoreboard-margin">
        <app-momentum-chart [match]="match"></app-momentum-chart>
    </div>

    <!-- Stats -->
    <div [hidden]="segment?.value !== 'stats'">
        <app-stats [match]="match" #stats></app-stats>
    </div>

    <div *ngIf="segment?.value === 'video'" class="">
        <app-video-tab [match]="match"></app-video-tab>
    </div>

    <ion-fab *ngIf="segment.value === 'momentum'" vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button color="dark" (click)="content.scrollToTop(300)">
            <ion-icon name="arrow-up-outline"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>

<app-stats-filters *ngIf="(match?.matchStatus !== 'TBP' && segment?.value === 'stats')" [match]="match" (updateFilters)="updateStats($event)"></app-stats-filters>